const STORAGE_KEY = "persistent_state";

export function save(state: any) {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  return Promise.resolve({});
}

export function load() {
  const state = window.localStorage.getItem(STORAGE_KEY);
  if (state) {
    try {
      return Promise.resolve(JSON.parse(state));
    } catch {
      return {};
    }
  }

  return {};
}
